import { render } from "./normal-match-players.template.html?vue&type=template&id=373849c4&scoped=true"
import script from "./NormalMatchPlayers.vue?vue&type=script&lang=ts"
export * from "./NormalMatchPlayers.vue?vue&type=script&lang=ts"

import "./NormalMatchPlayers.vue?vue&type=style&index=0&id=373849c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-373849c4"

export default script